import {SortableListContainer} from './SortableListContainer'
import {SortableListItem} from './SortableListItem'

export const DragAndDrop = Object.assign(SortableListContainer, {
  Item: SortableListItem,
})

try{ DragAndDrop.displayName ||= 'DragAndDrop' } catch {}